import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner/spinner-service';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(SpinnerService);
  if (req.headers.has('skip-spinner')) {
    return next(req);
  }

  spinner.show();

  return next(req).pipe(finalize(() => spinner.hide()));
};
